import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';
import { environment } from 'environments/environment';

/**
 * Firebase production configuration for dipitatouch-staging project
 * Configuration obtained from Firebase Console
 * Used for client-side initialization (web and mobile)
 */
const firebaseConfig = environment.firebase.config

/**
 * Initialize Firebase application with production configuration
 */
export const app = initializeApp(firebaseConfig);

/**
 * Lazy initialization of Firebase Cloud Messaging service
 * Only initializes on web platform where service workers are available
 * Returns null on native platforms to prevent service worker errors
 */
let _messaging: Messaging | null = null;

export function getMessagingInstance(): Messaging | null {
  // Only initialize messaging on web platform
  // Native platforms use Capacitor Push Notifications instead
  if (Capacitor.isNativePlatform()) {
    return null;
  }

  // Check if service workers are available before initializing
  // In iOS WebView, navigator.serviceWorker may exist but be undefined
  if (
    typeof navigator !== 'undefined' &&
    'serviceWorker' in navigator &&
    navigator.serviceWorker !== undefined
  ) {
    if (!_messaging) {
      try {
        _messaging = getMessaging(app);
      } catch (error) {
        console.warn('[Firebase Config] Failed to initialize messaging:', error);
        return null;
      }
    }
    return _messaging;
  }

  return null;
}


/**
 * VAPID (Voluntary Application Server Identification) key for web push notifications
 * Required for browser-based push notifications
 * Key obtained from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
 */
export const vapidKey = environment.firebase.vapidKey;
